"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var draft_js_1 = require("draft-js");
var IconButton_1 = __importDefault(require("material-ui/IconButton"));
var format_bold_1 = __importDefault(require("material-ui/svg-icons/editor/format-bold"));
var format_italic_1 = __importDefault(require("material-ui/svg-icons/editor/format-italic"));
var format_underlined_1 = __importDefault(require("material-ui/svg-icons/editor/format-underlined"));
var format_list_numbered_1 = __importDefault(require("material-ui/svg-icons/editor/format-list-numbered"));
var format_list_bulleted_1 = __importDefault(require("material-ui/svg-icons/editor/format-list-bulleted"));
var looks_one_1 = __importDefault(require("material-ui/svg-icons/image/looks-one"));
var looks_two_1 = __importDefault(require("material-ui/svg-icons/image/looks-two"));
var format_align_left_1 = __importDefault(require("material-ui/svg-icons/editor/format-align-left"));
var format_align_right_1 = __importDefault(require("material-ui/svg-icons/editor/format-align-right"));
var format_align_center_1 = __importDefault(require("material-ui/svg-icons/editor/format-align-center"));
var format_align_justify_1 = __importDefault(require("material-ui/svg-icons/editor/format-align-justify"));
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var lodash_1 = require("lodash");
var immutable_1 = __importDefault(require("immutable"));
exports.alignBlocks = ['align-left', 'align-right', 'align-center', 'align-justify'];
exports.combinationBlock = {
    'header-one': { element: 'h1' },
    'header-two': { element: 'h2' },
    'header-three': { element: 'h3' },
    'header-four': { element: 'h4' },
    'header-five': { element: 'h5' },
    'header-six': { element: 'h6' },
    blockquote: { element: 'blockquote' },
};
var createBlockRenderMap = function () {
    var blocks = exports.alignBlocks.map(function (align) { return lodash_1.mapKeys(exports.combinationBlock, function (value, key) { return align + "," + key; }); });
    return blocks.reduce(function (acc, value) { return (__assign({}, acc, value)); });
};
exports.blockRenderMap = immutable_1.default.Map(__assign({ 'align-left': { element: 'div' }, 'align-right': { element: 'div' }, 'align-center': { element: 'div' }, 'align-justify': { element: 'div' }, 'page-break': { element: 'div' } }, createBlockRenderMap()));
exports.extendedBlockRenderMap = draft_js_1.DefaultDraftBlockRenderMap.merge(exports.blockRenderMap);
exports.blockStyleFn = function (contentBlock) {
    var listType = contentBlock.getData().get('listType');
    if (listType) {
        return listType;
    }
    return contentBlock.getType().replace(',', ' ');
};
var RichEditor = /** @class */ (function (_super) {
    __extends(RichEditor, _super);
    function RichEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focus = function () {
            if (_this.editor) {
                _this.editor.focus();
            }
        };
        _this.handleKeyCommand = function (command) {
            var _a = _this.props, value = _a.value, onChange = _a.onChange;
            var newState = draft_js_1.RichUtils.handleKeyCommand(value, command);
            if (newState) {
                onChange(newState);
                return true;
            }
            return false;
        };
        _this.onTab = function (e) {
            var _a = _this.props, value = _a.value, onChange = _a.onChange;
            var maxDepth = 4;
            onChange(draft_js_1.RichUtils.onTab(e, value, maxDepth));
        };
        _this.toggleBlockType = function (blockType) {
            var _a = _this.props, value = _a.value, onChange = _a.onChange;
            onChange(draft_js_1.RichUtils.toggleBlockType(value, blockType));
        };
        _this.toggleInlineStyle = function (inlineStyle) {
            var _a = _this.props, value = _a.value, onChange = _a.onChange;
            onChange(draft_js_1.RichUtils.toggleInlineStyle(value, inlineStyle));
        };
        return _this;
    }
    RichEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, onChange = _a.onChange, readOnly = _a.readOnly;
        return (react_1.default.createElement("div", { className: readOnly ? 'editor readOnly' : 'editor' },
            react_1.default.createElement("div", { className: "editor-controls" },
                react_1.default.createElement(BlockStyleControls, { editorState: value, onToggle: this.toggleBlockType }),
                react_1.default.createElement(InlineStyleControls, { editorState: value, onToggle: this.toggleInlineStyle })),
            react_1.default.createElement("div", { onClick: this.focus, className: "writing-area" },
                react_1.default.createElement(draft_js_1.Editor, { blockRenderMap: exports.extendedBlockRenderMap, blockStyleFn: exports.blockStyleFn, editorState: value, handleKeyCommand: this.handleKeyCommand, onChange: onChange, onTab: this.onTab, ref: function (node) { return (_this.editor = node); }, spellCheck: true, readOnly: readOnly }))));
    };
    RichEditor.defaultProps = { value: draft_js_1.EditorState.createEmpty() };
    return RichEditor;
}(react_2.Component));
var StyleButton = /** @class */ (function (_super) {
    __extends(StyleButton, _super);
    function StyleButton() {
        var _this = _super.call(this) || this;
        _this.onToggle = function (e) {
            e.preventDefault();
            _this.props.onToggle(_this.props.format);
        };
        return _this;
    }
    StyleButton.prototype.render = function () {
        return react_1.default.createElement(IconButton_1.default, { onMouseDown: this.onToggle }, react_1.default.Children.only(this.props.children));
    };
    return StyleButton;
}(react_1.default.Component));
var pointer = { cursor: 'pointer ' };
var BlockStyleControlsBase = function (props) {
    var editorState = props.editorState;
    var selection = editorState.getSelection();
    var blockType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();
    return (react_1.default.createElement("div", { className: "RichEditor-controls" },
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "header-one" },
            react_1.default.createElement(looks_one_1.default, { color: blockType === 'header-one' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "header-two" },
            react_1.default.createElement(looks_two_1.default, { color: blockType === 'header-two' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "unordered-list-item" },
            react_1.default.createElement(format_list_bulleted_1.default, { color: blockType === 'unordered-list-item' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "ordered-list-item" },
            react_1.default.createElement(format_list_numbered_1.default, { color: blockType === 'ordered-list-item' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "align-left" },
            react_1.default.createElement(format_align_left_1.default, { color: blockType === 'align-left' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "align-right" },
            react_1.default.createElement(format_align_right_1.default, { color: blockType === 'align-right' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "align-center" },
            react_1.default.createElement(format_align_center_1.default, { color: blockType === 'align-center' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "align-justify" },
            react_1.default.createElement(format_align_justify_1.default, { color: blockType === 'align-justify' ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer }))));
};
var InlineStyleControlsBase = function (props) {
    var currentStyle = props.editorState.getCurrentInlineStyle();
    return (react_1.default.createElement("div", { className: "RichEditor-controls" },
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "BOLD" },
            react_1.default.createElement(format_bold_1.default, { color: currentStyle.has('BOLD') ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "ITALIC" },
            react_1.default.createElement(format_italic_1.default, { color: currentStyle.has('ITALIC') ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer })),
        react_1.default.createElement(StyleButton, { onToggle: props.onToggle, format: "UNDERLINE" },
            react_1.default.createElement(format_underlined_1.default, { color: currentStyle.has('UNDERLINE') ? lodash_1.get(props, 'muiTheme.editor.color') : 'black', style: pointer }))));
};
var themeable = muiThemeable_1.default();
var InlineStyleControls = themeable(InlineStyleControlsBase);
var BlockStyleControls = themeable(BlockStyleControlsBase);
exports.default = RichEditor;
exports.createValue = function (rawContent) {
    return lodash_1.isEmpty(rawContent)
        ? draft_js_1.EditorState.createEmpty()
        : draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(JSON.parse(rawContent)));
};
var createRawContentState = function (editorState) { return JSON.stringify(draft_js_1.convertToRaw(editorState.getCurrentContent())); };
var FormEditor = /** @class */ (function (_super) {
    __extends(FormEditor, _super);
    function FormEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: exports.createValue(_this.props.input.value),
        };
        _this.handleChange = function (editorState) {
            _this.setState({ value: editorState }, _this.afterChange(editorState));
        };
        _this.afterChange = function (editorState) {
            var input = _this.props.input;
            input.onChange(createRawContentState(editorState));
        };
        _this.syncStateWithProps = lodash_1.debounce(function (newValue) {
            var currentRawContet = draft_js_1.convertToRaw(_this.state.value.getCurrentContent());
            var rawContent = lodash_1.isEmpty(newValue) ? draft_js_1.convertToRaw(draft_js_1.ContentState.createFromText('')) : JSON.parse(newValue);
            if (!lodash_1.isEqual(rawContent, currentRawContet)) {
                // sync props contentState to state
                var newEditorState = draft_js_1.EditorState.push(_this.state.value, draft_js_1.convertFromRaw(rawContent), 'insert-characters');
                _this.setState({ value: draft_js_1.EditorState.moveSelectionToEnd(newEditorState) });
            }
        }, 10);
        return _this;
    }
    FormEditor.prototype.componentWillReceiveProps = function (nextProps) {
        this.syncStateWithProps(nextProps.input.value);
    };
    FormEditor.prototype.render = function () {
        var _a = this.props, input = _a.input, meta = _a.meta, editorName = _a.editorName, rest = __rest(_a, ["input", "meta", "editorName"]);
        var value = this.state.value;
        return react_1.default.createElement(RichEditor, __assign({ onChange: this.handleChange, value: value }, rest));
    };
    return FormEditor;
}(react_2.Component));
exports.FormEditor = FormEditor;
//# sourceMappingURL=Editor.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Editor.js
// module id = 1093
// module chunks = 0